const EDIT_APP_COMPANY_CONTACT_DRAFT_PREFIX = 'admin:appCompanyContactDraft:edit:'

const getSessionStorage = () => {
    if (typeof window === 'undefined') {
        return null
    }

    return window.sessionStorage
}

const normalizeMemoValue = (value) => {
    if (value === undefined || value === null) {
        return ''
    }

    return String(value)
}

// 도입문의 상세는 운영자가 다시 써야 하는 메모 값만 sessionStorage에 남긴다.
export const createAppCompanyContactDraftPayload = ({ params = {} }) => {
    return {
        params: {
            memo: normalizeMemoValue(params.memo),
        }
    }
}

// 서버 기본값 위에 draft만 덮어써서 새로고침 뒤에도 메모 작성 흐름을 이어간다.
export const applyAppCompanyContactDraft = ({ baseParams = {}, draft }) => {
    if (!draft) {
        return {
            params: {
                ...baseParams,
                memo: normalizeMemoValue(baseParams.memo),
            },
        }
    }

    const draftParams = draft.params || {}

    return {
        params: {
            ...baseParams,
            memo: draftParams.memo === undefined
                ? normalizeMemoValue(baseParams.memo)
                : normalizeMemoValue(draftParams.memo),
        }
    }
}

export const createEditAppCompanyContactDraftKey = (companyContactId) => `${EDIT_APP_COMPANY_CONTACT_DRAFT_PREFIX}${companyContactId}`

export const readAppCompanyContactDraft = (draftKey) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return null
    }

    try {
        const storedValue = storage.getItem(draftKey)
        return storedValue ? JSON.parse(storedValue) : null
    } catch (_error) {
        return null
    }
}

export const saveAppCompanyContactDraft = (draftKey, draftValue) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return
    }

    try {
        storage.setItem(draftKey, JSON.stringify(draftValue))
    } catch (_error) {
        // sessionStorage가 막혀 있어도 작성 흐름은 그대로 유지한다.
    }
}

export const clearAppCompanyContactDraft = (draftKey) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return
    }

    try {
        storage.removeItem(draftKey)
    } catch (_error) {
        // storage 정리에 실패해도 화면 동작은 계속 진행한다.
    }
}
